import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#eb166a',
        secondary: '#404040',
      },
    },
    options: {
      customProperties: true,
    },
  },
});
